<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t("accounts.title") }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">
            {{ $t("general.home") }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/accounts">
            {{ $tc("accounts.account", 2) }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $t("general.connect_to_form") }}
          </router-link>
        </li>
      </ol>
    </div>
    <SingleAccountRow :fetchData="fetchFunderData" :tableDivId="tableDivId" />
    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <astronaut-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{
          $t("islamic_finance_form_template.no_form")
        }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("islamic_finance_form_template.list_of_from")
        }}</label>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ totalFormTemplates }}</b>
        </p>

        <transition name="fade" v-if="connectFormDisable == false">
          <v-dropdown v-if="selectedIslamicForm > 0" :show-arrow="false">
            <span
              slot="activator"
              href="#"
              class="table-actions-button dropdown-toggle"
            >
              {{ $t("general.actions") }}
            </span>
            <v-dropdown-item>
              <div class="dropdown-item" @click="connectFundertoForm">
                <font-awesome-icon
                  icon="paper-plane"
                  class="dropdown-item-icon"
                />
                {{ $t("general.connect_to_form") }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control"></div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-radio">
              <input
                :disabled="connectFormDisable"
                :id="row.id"
                v-model="selectFormField"
                :value="row.id"
                type="radio"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>

        <table-column
          :sortable="true"
          :label="$t('user_guides.name')"
          show="name"
        />
        <table-column
          :label="$t('user_guides.added_on')"
          sort-as="created_at"
          show="formattedCreatedAt"
        />
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DotIcon from "../../../components/icon/DotIcon";
import AstronautIcon from "../../../components/icon/AstronautIcon.vue";
import SingleAccountRow from "./SingleAccountRow.vue";
export default {
  components: {
    DotIcon,
    AstronautIcon,
    SingleAccountRow
  },
  data() {
    return {
      fetchFunderData: [],
      tableDivId: "tableDivId",
      isRequestOngoing: true,
      connectFormDisable: false,
      totalFormTemplates: 0
    };
  },
  created() {
    this.loadAccount();
  },
  computed: {
    ...mapGetters("account", [
      "accounts",
      "selectedAccounts",
      "selectedIslamicForm",
      "totalAccounts",
      "selectAllField",
      "funderAccounts",
      "totalFunderAccounts",
      "selectAllFunderField"
    ]),
    showEmptyScreen() {
      return !this.totalFormTemplates && !this.isRequestOngoing;
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    selectFormField: {
      get: function() {
        return this.selectedIslamicForm;
      },
      set: function(val) {
        this.selectIslamicForm(val);
      }
    }
  },
  methods: {
    ...mapActions("account", [
      "fetchViewAccount",
      "fetchFunderFreeAudit",
      "selectIslamicForm",
      "connectFunderIslamicForm"
    ]),
    ...mapActions("islamicFormTemplate", ["fetchFormTemplates"]),

    async loadAccount() {
      this.isRequestOngoing = true;
      let response = await this.fetchViewAccount(this.$route.params.id);
      if (response.data) {
        this.fetchFunderData.push(response.data.account);
      }
      this.isRequestOngoing = false;
    },
    async fetchData({ page, per_page, filter, sort }) {
      let data = {
        orderByField: sort.fieldName || "users.created_at",
        orderBy: sort.order || "desc",
        status: "active",
        per_page, // Add rowsPerPage in the API request
        page
      };
      this.isRequestOngoing = true;
      let response = await this.fetchFormTemplates(data);
      this.isRequestOngoing = false;
      this.formTemplates = response.data.formTemplates.data;
      this.totalFormTemplates = response.data.formTemplates.total;
      return {
        data: this.formTemplates,
        pagination: {
          totalPages: response.data.formTemplates.last_page,
          currentPage: page,
          rowsPerPage: response.data.formTemplates.per_page // Add rowsPerPage in the API request
        }
      };
    },
    async connectFundertoForm() {
      let data = {
        funderId: this.$route.params.id,
        formId: this.selectedIslamicForm
      };
      this.isRequestOngoing = true;
      this.connectFormDisable = true;
      this.isLoading = true;
      let response = await this.connectFunderIslamicForm(data);

      if (response.data.success) {
        this.$router.push("/super-admin/accounts");
        window.toastr["success"](
          this.$tc("accounts.funder_form_link_successful")
        );
      }
    }
  }
};
</script>
<style scoped>
#tableDivId {
  min-height: 0px;
}
</style>
